
export class AudioBufferLoader {
  private static bufferCache: Record<string, AudioBuffer> = {};

  public static async load(ctx: AudioContext, source: string): Promise<AudioBuffer | null> {
    if (this.bufferCache[source]) return this.bufferCache[source];

    try {
      let arrayBuffer: ArrayBuffer;
      if (source.startsWith('http') || source.startsWith('/')) {
        const resp = await fetch(source);
        arrayBuffer = await resp.arrayBuffer();
      } else {
        const bin = atob(source.split(',')[1] || source);
        const bytes = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
        arrayBuffer = bytes.buffer;
      }
      const buf = await ctx.decodeAudioData(arrayBuffer);
      this.bufferCache[source] = buf;
      return buf;
    } catch (e) {
      console.error("Audio decode failed", e);
      return null;
    }
  }

  public static getFromCache(source: string): AudioBuffer | null {
      return this.bufferCache[source] || null;
  }
}
